<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="auto"
    title="公告"
    class="annmt-dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <div class="dialog-body" v-if="announcement">
      <img v-if="announcement.image_url" class="img" :src="announcement.image_url" alt="" />
      <img v-else class="img" src="@/assets/image/AnnmtImg.png" alt="" />
      <div class="text" v-html="safeAnnouncementContent"></div>
      <div class="submit-btn" @click="handleSubmit">我知道了</div>
    </div>
  </el-dialog>
</template>

<script>
import { fetchActiveAnnouncements, markAnnouncementRead } from "@/services/announcement";
import { sanitizeHTML } from "@/utils/safeHtml";

export default {
  name: "AnnmtDialog",
  props: {
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      announcement: null,
    };
  },
  computed: {
    dialogVisible: {
      get() { return this.visible; },
      set(v) { this.$emit("update:visible", v); },
    },
    safeAnnouncementContent() {
      return sanitizeHTML(this.announcement && this.announcement.content);
    },
  },
  watch: {
    visible(val) {
      if (val) this.loadAnnouncement();
    },
  },
  methods: {
    async loadAnnouncement() {
      try {
        const items = await fetchActiveAnnouncements("popup");
        const unread = items.filter((a) => !a.is_read);
        this.announcement = unread.length > 0 ? unread[0] : items[0] || null;
        if (!this.announcement) {
          this.dialogVisible = false;
        }
      } catch (_) {
        this.dialogVisible = false;
      }
    },
    async handleSubmit() {
      if (this.announcement) {
        try { await markAnnouncementRead(this.announcement.id); } catch (_) { /* ignore */ }
      }
      this.dialogVisible = false;
    },
    handleClose() {
      this.handleSubmit();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__close {
  margin-top: -10px !important;
  font-size: 24px !important;
}
::v-deep .el-dialog__close:hover {
  color: #ff7d00 !important;
}
::v-deep .el-dialog {
  border-radius: 12px !important;
  width: fit-content;
  min-width: 300px;
  max-width: 560px;
}
::v-deep .el-dialog__header {
  text-align: center;
  padding: 20px 0 0;
  border-bottom: none;
  .el-dialog__title {
    font-size: 22px;
    font-weight: 400;
    color: #333333;
  }
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
.dialog-body {
  padding: 20px 40px 40px;
  .img {
    width: 199px;
    height: 93px;
    margin: 0 auto;
    display: block;
  }
  .text {
    text-align: center;
    line-height: 24px;
    font-size: 14px;
    color: #444a50;
    margin-top: 16px;
    span { color: #ff7d00; }
    p { margin: 0 0 8px; }
    p:last-child { margin-bottom: 0; }
  }
}
.submit-btn {
  width: 100%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  border-radius: 22px;
  background: #ff7d00;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 36px;
  transition: background 0.3s;
  box-shadow: 0px 10px 24px 0px rgba(255, 132, 0, 0.4);
  &:hover { background: #e67400; }
  &:active { background: #d96c00; }
}
</style>
